export default "__VITE_ASSET__d2539c62__"